var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.5l5.2-5.2a1 1 0 00.3-.71V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2.59c0 .26.1.52.3.7l5.2 5.21m0 0v6.25c0 .81.76 1.4 1.55 1.21l2.5-.62c.56-.14.95-.64.95-1.22V13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFilter;